import React from "react"
import { withTheme } from "emotion-theming"
import VisuallyHidden from "@reach/visually-hidden"

import { ViewButton } from "@components/button"
import Circle from "@components/circle"
import { Row, Col } from "@components/grid"
import Infographic from "@components/infographic"
import Panel from "@components/panel"

import { Carrot, Megaphone, Utensils } from "@svgs"

const sectionTitle = "Hamilton Community Food Centre"

const Community = ({ theme }) => (
  <section>
    <Panel maxWidth="1200px" background={theme.color}>
      <h1>{sectionTitle}</h1>
      <Row>
        <Col width={[1, 1, 1 / 2]}>
          <h3>Increasing access to healthy food</h3>
        </Col>
        <Col width={[1, 1, 1 / 2]}>
          <h3>Building healthy food skills and behaviours</h3>
        </Col>
      </Row>
      <Row mb={5}>
        <Col width={[1, 1, 1 / 2]}>
          <Infographic
            icon={<Carrot />}
            value="11,937"
            direction="row"
            colour={theme.colours.secondary}
          >
            healthy meals served and sent home
          </Infographic>
          <Infographic
            icon={<Circle value={88} />}
            value="88%"
            direction="row"
            colour={theme.colours.secondary}
          >
            of people surveyed say our programs provide an important source of
            healthy food
          </Infographic>
        </Col>
        <Col width={[1, 1, 1 / 2]}>
          <Infographic
            icon={<Utensils />}
            value="218"
            direction="row"
            colour={theme.colours.warning}
          >
            food Skills sessions offered
          </Infographic>
          <Infographic
            icon={<Circle value={81} />}
            value="81%"
            direction="row"
            colour={theme.colours.warning}
          >
            say they're eating more fruits and vegetables
          </Infographic>
        </Col>
      </Row>
      <Row>
        <Col width={[1, 1, 1 / 2]}>
          <h3>Reducing social isolation &amp; increasing support</h3>
        </Col>
        <Col width={[1, 1, 1 / 2]}>
          <h3>Increasing access to healthy food</h3>
        </Col>
      </Row>
      <Row>
        <Col width={[1, 1, 1 / 2]}>
          <Infographic
            icon={<Megaphone />}
            value="1,320"
            direction="row"
            colour={theme.colours.primary}
          >
            visits to the Advcacy Office for Support
          </Infographic>
          <Infographic
            icon={<Circle value={95} />}
            value="95%"
            direction="row"
            colour={theme.colours.primary}
          >
            feel they belong to a community at The Hamilton CFC
          </Infographic>
        </Col>
        <Col width={[1, 1, 1 / 2]}>
          <Infographic
            icon={<Circle value={74} />}
            value="74%"
            direction="row"
            colour={theme.colours.success}
          >
            of people surveyed say our programs provide an important source of
            healthy food
          </Infographic>
        </Col>
      </Row>
      <ViewButton to="/community" colour={theme.backgroundColor}>
        View
        <VisuallyHidden> {sectionTitle}</VisuallyHidden>
      </ViewButton>
    </Panel>
  </section>
)

export default withTheme(Community)
